// mini-cart-quantity.js
document.addEventListener('DOMContentLoaded', () => {
  // When user clicks + or – or edits the number field…
  document.body.addEventListener('click', onQtyButton);
  document.body.addEventListener('change', onQtyInputChange);

  function onQtyButton(evt) {
    const btn = evt.target.closest('.quantity__button');
    if (!btn) return;

    evt.preventDefault();
    const input = btn
      .closest('quantity-input')
      .querySelector('input.quantity__input');
    let qty = parseInt(input.value, 10) || 1;

    if (btn.getAttribute('aria-label') === 'quantity-plus') {
      qty++;
    } else if (qty > 1) {
      qty--;
    }

    updateCartLine(input.dataset.line, qty);
  }

  function onQtyInputChange(evt) {
    if (!evt.target.matches('input.quantity__input')) return;
    let qty = parseInt(evt.target.value, 10) || 1;
    if (qty < 1) qty = 1;
    updateCartLine(evt.target.dataset.line, qty);
  }

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line,10), quantity })
    })
    .then(() => {
      // re-fetch only the two snippets that make up your mini-cart
      return fetch(`/?sections=cart-sidebar-items,cart-sidebar-footer`);
    })
    .then(r => r.text())
    .then(html => {
      const parser = new DOMParser();
      const doc    = parser.parseFromString(html, 'text/html');

      // swap out the items list
      const newItems  = doc.querySelector('.cart-sidebar__items');
      const oldItems  = document.querySelector('.cart-sidebar__items');
      if (newItems && oldItems) oldItems.replaceWith(newItems);

      // swap out the footer (totals + buttons + your $50 logic)
      const newFooter = doc.querySelector('.cart-sidebar__footer');
      const oldFooter = document.querySelector('.cart-sidebar__footer');
      if (newFooter && oldFooter) oldFooter.replaceWith(newFooter);
    })
    .catch(console.error);
  }
});
